import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import {
  RewardsDetails,
  RewardsList,
  RewardsFilter,
  RewardsListingQueryParameters,
  RewardsModal,
  RibbonsList,
} from "./types";

export const rewardInitialstate: RewardsModal = {
  rewardsList: {
    data: [],
    total: 0,
    pageNo: 0,
    totalPage: 0,
    nextHit: 0,
    limit: 0,
  },
  rewardsListingQueryParameters: {
    pageNo: 1,
    limit: 10,
    searchKey: "",
  },

  rewardsFilter: {
    type: [],
    status: [],
    toDate: null,
    fromDate: null,
  },

  rewardsDetails: {
    _id: "",
    name: "",
    type: "",
    status: "",
    created: 0,
    userType: "",
    createdAt: "",
    updatedAt: "",
    description: "",
    maxRedemptionLimit: 0,
    consumerRedemptionLimit: 0,
    ribbons: [],
    image: "",
    totalCount: "",
  },

  ribbonsList: {
    data: [],
  },
  dateRange: undefined,
};
const RewardsManagementModuleSlice = createSlice({
  name: "rewards-management",
  initialState: rewardInitialstate,
  reducers: {
    setRewardsListingData: (
      state: RewardsModal,
      action: PayloadAction<RewardsList>,
    ) => {
      state.rewardsList = { ...action.payload };
    },
    setRewardsListingQueryParameters: (
      state: RewardsModal,
      action: PayloadAction<RewardsListingQueryParameters>,
    ) => {
      state.rewardsListingQueryParameters = { ...action.payload };
    },
    setRewardsDetails: (
      state: RewardsModal,
      action: PayloadAction<RewardsDetails>,
    ) => {
      state.rewardsDetails = action.payload;
    },

    setRewardsFilter: (
      state: RewardsModal,
      action: PayloadAction<RewardsFilter>,
    ) => {
      state.rewardsFilter = action.payload;
    },

    setDateRange: (
      state: RewardsModal,
      action: PayloadAction<[Date, Date] | undefined>,
    ) => {
      state.dateRange = action.payload;
    },
    setRibbonsData: (
      state: RewardsModal,
      action: PayloadAction<RibbonsList>,
    ) => {
      state.ribbonsList = action.payload;
    },
  },
});

export const {
  setRewardsListingData,
  setRewardsListingQueryParameters,
  setRewardsDetails,
  setRewardsFilter,
  setDateRange,
  setRibbonsData,
} = RewardsManagementModuleSlice.actions;
export default RewardsManagementModuleSlice.reducer;
